module.exports = __webpack_public_path__ + "media/media/service/training-6789921b76393e8a468a4c257cdf4bf8.png";